import {http} from "../api/cp"

function Request(method, url, data) {
	let isFormData = false;

	const createFormData = (formData, key, data) => {
		if(data === null) {
		} else if(data instanceof Array) {
			data.forEach((_value, index) => {
				createFormData(formData, key ? key + '[' + index + ']' : index, data[index]);
			});
		} else if('object' === typeof data && !(data instanceof File)) {
			Object.keys(data).forEach((index) => {
				createFormData(formData, key ? key + '[' + index + ']' : index, data[index]);
			});
		} else {
			if (data instanceof File) {
				isFormData = true;
			}
			formData.append(key, data);
		}
		return formData;
	};

	const request = {method, url};
	switch (method.toUpperCase()) {
		case 'GET':
		case 'DELETE':
			request.params = data;
			break;

		default:
			request.data = data;

			const formData = createFormData(new FormData(), '', data);
			if (isFormData) {
				request.data = formData;
			}
	}

    return new Promise((resolve, reject) => {
        http.request(request)
            .then(response => resolve(response.data, response.statusText, response.request))
            .catch(error => reject(error))
        ;
    });
}
Request.get = (url, data) => Request('GET', url, data);
Request.post = (url, data) => Request('POST', url, data);
Request.put = (url, data) => Request('PUT', url, data);
Request.delete = (url, data) => Request('DELETE', url, data);

export default Request;
